import React from "react";
import Footer from "../components/Frontend/Footer";
import Navbar from "../components/Frontend/Navbar";

const HomePageLayout = ({ children }) => {
  return (
    <div className="homepage-layout">
      <Navbar />
      <main className="">{children}</main>
      <Footer />
    </div>
  );
};

export default HomePageLayout;
